import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreUIIconsModule } from "../icons/core-ui-icons.module";
import { InlineLoadingComponent } from "./organism/inline-loading/inline-loading.component";
import { LoaderBaseComponent } from "./organism/loader-base/loader-base.component";
import { LoadingOverlayComponent } from "./organism/loading-overlay/loading-overlay.component";

@NgModule({
    declarations: [
        InlineLoadingComponent,
        LoaderBaseComponent,
        LoadingOverlayComponent
    ],
    imports: [
        CommonModule,
        CoreUIIconsModule
    ],
    exports: [
        InlineLoadingComponent,
        LoaderBaseComponent,
        LoadingOverlayComponent
    ]
})
export class CoreUiLoaderModule { }
